<span *ngIf="readOnly">{{dateViewBind}}</span>
<span *ngIf="!readOnly"><input #dateInput type="date" [(ngModel)]="dateBind" (change)="dateUpdated($event)" /></span>
